
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectWizardV2.html?raw';
import on from 'dojo/on';
import topic from 'dojo/topic';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import FloatingMenu from '../../moreCore/UI/Floating/Menu';
import "../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import "../../moreCore/UI/Container/ExpandableSectionTypes";

import { VAMtypes } from "../../WidgetCollection/_loadingHelpers/VAM";
import {
    ProjectWizardV2Base,
    ProjectWizardV2BaseBOB,
    ProjectWizardV2BaseAMBACH,
    ProjectWizardFiles
} from "../_loadingHelpers/VAMv2";
import { VAM2types, VAMclassNames } from "../_loadingHelpers/VAMv2Types";
import '../ProjectWizardV2/Base/ProjectWizardV2Base';
import '../ProjectWizardV2/BaseBOB/BaseBOB';
import '../ProjectWizardV2/Files/ProjectFiles';

import BookingList from '../ProjectWizard/BookingList/BookingList';
import "../ProjectWizard/BookingList/BookingList";
import EvProjectCopyForm from '../ProjectWizard/CopyForm/EvProjectCopyForm';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import CommdocList from '../Commdoc/CommdocList';
import ProjectReportOptionsForm from '../ProjectWizard/ProjectReportOptionsForm/ProjectReportOptionsForm';
import OMplannedMusicianList from '../ProjectWizard/PlannedMusician/PlannedMusicianList';
import TravelBookingsList from './Travel/TravelBookingsList';
import OrchestraMatrix from '../OrchestraMatrix/OrchestraMatrix';
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { FeatureHelpers, FileHelpers, ToasterHelpers, TranslationHelpers } from "../../more/Helpers";
import communicationDisplayTable from '../AddressWizard/ContactAndCommunication/communicationDisplayTable';
import communicationEditor from '../AddressWizard/ContactAndCommunication/communicationEditor';
import mdsRequire2 from 'dojo/require'; // EvProcessTable via registry: breaks the ProjectWizardV2->EvProcessTable->MainCatalogEditorTools ESM base-class cycle
import EvProjectCastList from './EvCast/EvProjectCastList';
import EvProjectProgramList from './EvProgram/EvProjectProgramList';
import filePreview from '../filePreview/filePreview';
import TodoAppointmentsTable from '../TodoAppointments/TodoAppointmentsTable';
import InvolvedAddressesList from './InvolvedAddresses/InvolvedAddressesList';
import FileDownloadHandler from '../../moreCore/UI/Filetransfer/FileDownloadHandler';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import CommdocConfigPanel from '../Commdoc/CommdocConfigPanel/CommdocConfigPanel';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';

class ProjectWizardV2 extends compose(_GlobalSelectEntityDialogsMixin, _StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private fdh: MdsLax<InstanceType<typeof FileDownloadHandler>> = null;
    private isPeriod: boolean = false;

    private headingLabel: HTMLElement;
    private headingProjectName: HTMLElement;
    private formContainer: HTMLElement;
    private baseForm: MdsLax<InstanceType<typeof ProjectWizardV2Base>>;
    private baseFormBOB: MdsLax<InstanceType<typeof ProjectWizardV2BaseBOB>>;
    private baseFormAMBACH: MdsLax<InstanceType<typeof ProjectWizardV2BaseAMBACH>>;
    private filesSection: MdsLax<InstanceType<typeof ProjectWizardFiles>>;

    private todoAppointmentsTable: MdsLax<InstanceType<typeof TodoAppointmentsTable>>;
    private evProcessTable: any;
    private commdocList: MdsLax<InstanceType<typeof CommdocList>>;
    private plannedMusicianList: MdsLax<InstanceType<typeof OMplannedMusicianList>>;

    private travelBookingsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private travelBookingsList: MdsLax<InstanceType<typeof TravelBookingsList>>;
    private sectionTravelBookings: HTMLElement;

    private evCastListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private evCastList: MdsLax<InstanceType<typeof EvProjectCastList>>;
    private sectionEvCastList: HTMLElement;

    private evProgramListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private evProgramList: MdsLax<InstanceType<typeof EvProjectProgramList>>;
    private sectionEvProgramList: HTMLElement;

    private involvedAddressesListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private involvedAddressesList: MdsLax<InstanceType<typeof InvolvedAddressesList>>;
    private sectionInvolvedAddresses: HTMLElement;

    private commdocExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private sectionCommdocs: HTMLElement;

    private plannedMusicansExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionPlannedMusicans: HTMLElement;
    private communicationListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private communicationList: MdsLax<InstanceType<typeof communicationDisplayTable>>;


    private sectionCommunicationList: HTMLElement;

    protected sectionEntityView_Top: HTMLElement;
    protected EntityViewContainer_Top: HTMLElement;
    protected sectionEntityView_MiddleTop: HTMLElement;
    protected EntityViewContainer_MiddleTop: HTMLElement;
    protected sectionEntityView_Bottom: HTMLElement;
    protected EntityViewContainer_Bottom: HTMLElement;

    private sectionTodoAppointments: HTMLElement;
    private sectionEvProcess: HTMLElement;
    private sectionFiles: HTMLElement;
    private sectionBaseForm: HTMLElement;
    private sectionBaseFormBOB: HTMLElement;
    private sectionBaseFormAMBACH: HTMLElement;

    bookingListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    bookingListContainer: HTMLElement;
    bookingList: MdsLax<InstanceType<typeof BookingList>>;

    private entity: VAM2types.EvProjectEntity_Extended;
    //private entityId: string = null;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    _request: any = null;


    public setIsPeriod(isPeriod: boolean) {
        this.isPeriod = isPeriod;
        this.baseForm.setIsPeriod(isPeriod);
    }

    private selfSetup() {
        if (this.isStarted) return;
        if (this.isEmbeddedInTab == true || this.dlg || this.domNode.parentNode) return; // setup war schon
        let id = this.entityId ? this.entityId : (Math.random() * 10000).toString();

        // das Widget versucht hier, sich als Tab anzumelden
        let title = this.entity && this.entityId ? this.entity.ev_project_name ? this.entity.ev_project_name : this.translations["General_Label_EvProject"] : this.translations["Projects__CreateNew"];
        this.show("tab", title, this.getTabContainerName());

        //this.createNewTabbedContent({
        //    enableClosing: true,
        //    label: this.entity && this.entityId ? this.entity.ev_project_name ? this.entity.ev_project_name : this.translations["General_Label_EvProject"] : this.translations["Projects__CreateNew"],
        //    name: id,
        //    sidebarEntryName: id,
        //    widget: this,
        //    iconclass: "fas fa-edit"
        //}, true);

        //// falls das nicht gelingt, wird ein Dlg erzeugt:
        //if (this.isEmbeddedInTab) {



        //    //this.requestTabswitch(this.internalName);
        //} else {
        //    this.dlg = new GenericDialog();

        //    this.dlg.keepOpen = true;

        //    this.dlg.show(
        //        this.formContainer,
        //        this.translations["ProjectWizard_dialogHeader"],
        //        null,
        //        null,
        //        "saveclose",
        //        lang.hitch(this, this._onDlgResult)
        //    );

        //    this.dlg.on("closed", lang.hitch(this, this._onDlgClosed));
        //    this.dlg.addButton("save", this.translations["General_Save"], lang.hitch(this, this.saveData), null, "accentBG", "fas fa-save", false, "first");
        //    this.dlg.disableButton("save");
        //}

    }



    //_onEmbedding() {
    //    this.UiModder.domClass.toggle(this.domNode, "border round padding", this.isEmbeddedInTab);
    //    this.hideNode(this.headingLabel, !this.isEmbeddedInTab);
    //}
    protected _onDisplaynameChange(newName: string) {
        this.headingProjectName.innerHTML = newName;
        this.hideNode(this.headingProjectName, false);

        this.setTitles(newName);

        //this.requestTabRename(newName);
    }

    _onCloseRequest() {
        let hasChanged = this.isDirty();

        if (hasChanged) {

            let dlgConfirm = new GenericDialog();
            dlgConfirm.setSize("smaller");
            dlgConfirm.show("General_AskSavePendingChanges",
                "General_PendingChanges",
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.close();
        } else if (result == 0) { // cancel

        }
        else {
            if (this.saveData() == true) {
                on(this, "saved", lang.hitch(this, this.close))
            }
        }
    }

    private _reload(): void {
        this.loadProjectById(this.entityId);
    }

    loadProjectById(id: string, temporaryLabel?: string) {

        //if (temporaryLabel) {
        //    this._setHeading(temporaryLabel);
        //}

        if (!this.hasUserRole("Projects_Read")) {
            alert("no privilege - not allowed to load project")
            return;
        }

        this.setStartupState("loading");

        this.entityId = id;

        this.StandbyStart();
        var url = window.appRoot + "ProjectWizard/GetProjectById";

        this.RequestManager.post(
            url,
            { jsonData: JSON.stringify({ id: id }) },
            lang.hitch(this, this._onGetProjectByIdResponse),
            lang.hitch(this, function (err: more.requestErrorMessage) {
                this.StandbyStop();
                this._request = null;
                if (err && err.Message) {
                    alert(err.Message);
                } else {
                    console.log(err);
                }
            }),
            false // sync
        );

    }

    private _onGetProjectByIdResponse(response: VAM2types.EvProjectEntity_Extended): void {

        if (this._destroyed) return;

        this.disableNode(this.formContainer, false);
        this._request = null;
        this.setEntity(response);


        this.StandbyStop();

    }

    protected onSetReadOnly(isReadonly: boolean) {
        if (this.filesSection) {
            if (isReadonly === true) {

            }
        }
    }

    setEntity(entity: VAM2types.EvProjectEntity_Extended) {
        this.setData(entity);
    }


    setData(entity: VAM2types.EvProjectEntity_Extended) {

        if (!entity) return;

        let id = entity.ID;
        if (id != this.entityId) this.isPrivilegesLoaded = false;

        this.entity = entity;
        this.entityId = id;



        if (!this.isPrivilegesLoaded) {
            // Abzweigen: erst mal asynchron Rechte checken. dann kommen wir wieder her
            this.webPrivilegeManager.loadPrivilegesForEntity(this.entityId ? this.entity : null, lang.hitch(this, this._onPrivilegesLoaded));

            return;
        }
        this.selfSetup();
        super.setData.apply(this, arguments as any);

        this.setIsPeriod(entity.ref_ev_project_type_2 && entity.ref_ev_project_type_2.ID === this._getProjectTypePeriodID() ? true : false);

        let showLists = !this.hasFeature("EvProject/PeriodProject") || !this.isPeriod;

        //Prüfung muss so erfolgen, damit die Reihenfolge der Expander passt
        if (showLists) this.handleBookingList();
        this.handleEvProgramList();
        this.handleEvCastList();
        if (showLists) {
            this.handleInvolvedAddressesList();
            this.handleCommdocList();
            this.handleCommunicationList();
            this.handlePlannedMusicianList();
            this.setupTravelBookingsSection();
            this.handleEvProcessList();
            this.handleTodoAppoinmentsList();
        }
    }

    afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this._setupEntityViews();
    }

    afterReady() {
        let isNew: boolean = !this.entityId;
        if (isNew) {
            if (this.hasFeature("EvProject/LoadDefaultValues")) {
                this.StandbyStart();
                this.RequestManager.callfunction("Webtool_API__ProjectWizard_LoadDefaultValues", {}, lang.hitch(this, this._onLoadDefaultValuesResponse), lang.hitch(this, this._onLoadDefaultValuesError));
            }
        }
    }

    private _onLoadDefaultValuesResponse(response: Record<string, any>) {
        this.StandbyStop();
        this.showToast({ title: "General_Success_LoadDefaultValues", iconClass: "fas fa-check", timeout: 2000 });
        for (let key of Object.keys(response)) {
            this.setAttributeValue(key, response[key]);
        }
    }

    private _onLoadDefaultValuesError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({ title: "General_Error_LoadDefaultValues", iconClass: "fas fa-exclamation-triangle", timeout: 5000 });
    }

    private _getProjectTypePeriodID(): string {
        let projectTypePeriodID: string;

        let module: { projectTypePeriodID: string } = this.getModule("EvProject");
        projectTypePeriodID = module.projectTypePeriodID;

        return projectTypePeriodID;
    }

    private handleBookingList() {

        if (!this.hasUserRole("EvBooking_Read")) {
            this.UiModder.domConstruct.empty(this.bookingListContainer);
            this.bookingList = null;
            this.hideNode(this.bookingListContainer);
            this.hideNode(this.bookingListExpander);
            return;
        }

        if (!this.bookingList) {
            this.bookingList = new BookingList();
            this.UiModder.domConstruct.place(this.bookingList.domNode, this.bookingListContainer);
            this.bookingList.on("loaded", lang.hitch(this, this._onBookingListLoaded));
        }
        //this.UiModder.domConstruct.empty(this.bookingListContainer);

        this.hideNode(this.bookingListExpander, false);
        this.hideNode(this.bookingListContainer, false);

        this.bookingList.loadData(this.entity);
        this.bookingList.tabContainerName = this.getTabContainerName();

    }

    private _onBookingListLoaded(): void {
        let bHasBookings = this.bookingList.getEntityListData().length > 0;
        this.bookingListExpander.setMarking(bHasBookings ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        //this.bookingListExpander.toggleExpand(false);
    }

    private _setupEntityViews() {

        this.hideNode(this.sectionEntityView_Top);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_Top);

        this.hideNode(this.sectionEntityView_MiddleTop);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_MiddleTop);

        this.UiModder.domConstruct.empty(this.EntityViewContainer_Bottom);
        this.hideNode(this.sectionEntityView_Bottom);

        if (!this.entityId) return;

        if (this.hasFeature("EvProject/EntityViewInEditor_Top")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_projects,
                this.getDisplayname(),
                "ev_project_name",
                this.EntityViewContainer_Top,
                null,
                "ProjectWizard_Top");


            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Top));

        }
        if (this.hasFeature("EvProject/EntityViewInEditor_MiddleTop")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_projects,
                this.getDisplayname(),
                "ev_project_name",
                this.EntityViewContainer_MiddleTop,
                null,
                "ProjectWizard_MiddleTop");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_MiddleTop));

        }
        if (this.hasFeature("EvProject/EntityViewInEditor_Bottom")) {
            this.hideNode(this.sectionEntityView_Bottom, false);

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_projects,
                this.getDisplayname(),
                "ev_project_name",
                this.EntityViewContainer_Bottom,
                null,
                "ProjectWizard_Bottom");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Bottom));

        }
    }

    private _onPrivilegesLoaded() {
        this.isPrivilegesLoaded = true;

        this.setData(this.entity);

        this._handlePrivileges();

    }

    save() {
        this.saveData();
    }

    private saveData(): boolean {
        if (this._request != null) {
            return false;
        }

        if (this.checkMandatoryInputs() != true) {
            this.showToast({
                title: this.translations["General_MandatoryMissing"],
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return false;
        }

        this.StandbyStart(this.formContainer);
        if (this.dlg) this.dlg.disableButton("save");

        setTimeout(lang.hitch(this, this.continueSaveData), 350); // onchangeds abwarten :-/

        return true;
    }

    private continueSaveData() {

        let data = lang.clone(this.changedData) as VAM2types.EvProjectEntity_Extended;

        if (this.entityId) data.ID = this.entityId;

        if (this.hasUserRole("_DEV")) console.log(this.id + " saveData:", data, this.changedData);


        this._request = this.RequestManager.callfunction(
            "Webtool_API_ProjectWizard__SaveProjectEntity",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError));
    }

    private _onSaveDataResponse(response) {
        this._request = null;

        if (response.ID) {
            this.showToast({
                title: this.translations["General_SavingSuccessful"],
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
                options: {
                    ID: this.entityId
                }
            });
            this.emit("saved", response);
            this.emit("saveComplete", response);
            this.StandbyStop();

            if (this._destroyed) return;
            this.resetDirty();
            this.loadProjectById(response.ID);

        } else {
            alert(this.id + " - unexpected response after saving: " + response);
            this.StandbyStop();
            if (this.dlg) this.dlg.enableButton("save");
        }
    }

    private _onSaveDataError(error: more.requestErrorMessage) {
        this._request = null;
        this.StandbyStop();
        if (this.dlg) this.dlg.enableButton("save");

        this.showToast({
            title: this.translate("General_SavingFailed"),
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message,
            options: {
                ID: this.entityId,
                timeout: 20000,
                closeButton: true
            }
        });
    }

    private deleteEvProject() {

        if (!this.hasUserRole("Projects_Delete")) return;

        if (!this.entity || !this.entity.ID) return;

        this.StandbyStart();

        let data = {
            entityID: this.entity.ID
        };

        let url = window.appRoot + "ProjectWizard/DeleteProject";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeleteProjectResponse),
            lang.hitch(this, this._onDeleteProjectError),
            false // sync
        );
    }

    private _onDeleteProjectResponse(response: { Exception: boolean, Message: string }) {

        topic.publish("EvProject/Deleted");

        this.StandbyStop();


        this.showToast({
            title: this.translations["General_DeletingSuccessful"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        this.emit("deleted");
        this.emit("entityDeleted");

        //if (this.isEmbeddedInTab) {
        //    this.closeTab();
        //}

        this.close();


    }

    private _onDeleteProjectError(error: more.requestErrorMessage) {
        this.StandbyStop();

        let dlg = new GenericDialog();
        dlg.show(error.Message,
            this.translations["General_DeletingFailed"],
            null, ToasterHelpers.ToasterIcons.error, "close");
    }

    //### TEMP - Wir müssen über eine einheitliche Lösung für EntityView und diesen Ort nachdenken!
    protected _onClick_OpenReportMenu(evt: MouseEvent, previousMenu: MdsLax<InstanceType<typeof FloatingMenu>>, entry) {


        let menu = new FloatingMenu();



        menu.addEntry({
            label: this.translations["General_Label_ProjectReport"],
            callback: lang.hitch(this, this._onClick_ProjectReport, menu.domNode),
            icon: "fas fa-file-alt",
            groupname: entry.label,
            heading: entry.label,
            hasNextLevel: true
        });

        previousMenu.openNextLevel(menu);
        //previousMenu.openNextLevelV2(menu, evt, entry);

        //menu.open(evt);
    }

    private _onClick_ProjectReport(node: HTMLElement): void {
        this.StandbyStart();
        let url = window.appRoot + "Downloads/ProjectReport";

        if (this.hasFeature("EvProject/ProjectReportOptions") === true) {

            let optionsDlg = new ProjectReportOptionsForm();
            optionsDlg.displayOptionsDialog(this.entityId, lang.hitch(this, this._sendProjectRequest, url));
            optionsDlg.on("projectreport_cancelled", () => { this.StandbyStop(); });
            return;
        }

        let data = { "projectID": this.entityId };
        let stringData = JSON.stringify(data);

        this._sendProjectRequest(url, stringData);
    }
    //### TEMP

    protected _onClick_OpenCommdocsMenu(evt) {
        //let menu = new FloatingMenu();

        //let module = this.getModule("Commdoc");

        //Menüs
        this.addButtonMenuEx(
            {
                label: this.translate("Commdoc_Label_Menu_Offer"),
                internalName: "offer",
                bIsGroupNextLevel: true,
                parentGroupName: "commdocs",
                iconClass: "far fa-file-alt",
                
            }
        )

        this.addButtonMenuEx(
            {
                label: this.translate("Commdoc_Label_Menu_Contract"),
                internalName: "contract",
                bIsGroupNextLevel: true,
                parentGroupName: "commdocs",
                iconClass: "fas fa-file-alt"
            }
        )

        this.addButtonMenuEx(
            {
                label: this.translate("Commdoc_Label_Menu_Info"),
                internalName: "info",
                bIsGroupNextLevel: true,
                parentGroupName: "commdocs",
                iconClass: "fas fa-info"
            }
        )

        this.addButtonMenuEx(
            {
                label: this.translate("Commdoc_Label_Menu_Invoice"),
                internalName: "invoice",
                bIsGroupNextLevel: true,
                parentGroupName: "commdocs",
                iconClass: "fas fa-file-invoice-dollar"
            }
        )

        this.addButtonMenuEx(
            {
                label: this.translate("Commdoc_Label_Menu_Order"),
                internalName: "order",
                bIsGroupNextLevel: true,
                parentGroupName: "commdocs",
                iconClass: "fas fa-clipboard-list"
            }
        )

        //ANGEBOT
        if (this.hasFeature("Commdoc/CreateOffer")) {
            this.addButtonEx({
                label: this.translate("Commdoc_Label_Offer"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_offer"),
                iconClass: "far fa-file-alt",
                groupname: "offer",
                position: "secondary",
                internalName: "createOffer"
            });
        }
        if (this.hasFeature("Commdoc/CreateOffer_E")) {
            this.addButtonEx({
                label: this.translate("Commdoc_Label_Offer_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_offer_E"),
                iconClass: "far fa-file-alt",
                groupname: "offer",
                position: "secondary",
                internalName: "createOffer_E"
            });
        }
        //VORAUSZAHLUNG
        if (this.hasFeature("Commdoc/CreatePrepayment")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_Prepayment"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_prepayment"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createPrepayment"
            });
        }
        if (this.hasFeature("Commdoc/CreatePrepayment_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_Prepayment_E"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_prepayment_E"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createPrepayment_E"
            });
        }
        //RECHNUNG
        if (this.hasFeature("Commdoc/CreateInvoice")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_Invoice"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoice"
            });
        }
        if (this.hasFeature("Commdoc/CreateInvoice_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_Invoice_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice_E"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoice_E"
            });
        }
        //SCHLUSSRECHNUNG
        if (this.hasFeature("Commdoc/CreateClosingInvoice")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_ClosingInvoice"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_closing_invoice"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createClosingInvoice"
            });
        }
        if (this.hasFeature("Commdoc/CreateClosingInvoice_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_ClosingInvoice_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_closing_invoice_E"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createClosingInvoice_E"
            });
        }
        //RECHNUNG Gutschrift
        if (this.hasFeature("Commdoc/CreateInvoiceCredit")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_InvoiceCredit"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice_credit"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoiceCredit"
            });
        }
        if (this.hasFeature("Commdoc/CreateInvoiceCredit_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_InvoiceCredit_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice_credit_E"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoiceCredit_E"
            });
        }
        //RECHNUNG Stornogebühr
        if (this.hasFeature("Commdoc/InvoiceCancelFee")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_InvoiceCancelFee"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice_cancel_fee"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoiceCancelFee"
            });
        }
        if (this.hasFeature("Commdoc/InvoiceCancelFee_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_InvoiceCancelFee_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_invoice_cancel_fee_E"),
                iconClass: "fas fa-file-invoice-dollar",
                groupname: "invoice",
                position: "secondary",
                internalName: "createInvoiceCancelFee_E"
            });
        }
        //EINZELAUFTRAG FREIBLEIBEND
        if (this.hasFeature("Commdoc/IndividualOrder")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_IndividualOrder"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_individual_order"),
                iconClass: "fas fa-clipboard-list",
                groupname: "order",
                position: "secondary",
                internalName: "createIndividualOrder"
            });
        }
        if (this.hasFeature("Commdoc/IndividualOrder_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_IndividualOrder_E"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_individual_order_E"),
                iconClass: "fas fa-clipboard-list",
                groupname: "order",
                position: "secondary",
                internalName: "createIndividualOrder_E"
            });
        }
        //EINZELAUFTRAG MIT OPTION
        if (this.hasFeature("Commdoc/IndividualOrderOption")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_IndividualOrderOption"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_individual_order_option"),
                iconClass: "fas fa-clipboard-list",
                groupname: "order",
                position: "secondary",
                internalName: "createIndividualOrderOption"
            });
        }
        if (this.hasFeature("Commdoc/IndividualOrderOption_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_IndividualOrderOption_E"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_individual_order_option_E"),
                iconClass: "fas fa-clipboard-list",
                groupname: "order",
                position: "secondary",
                internalName: "createIndividualOrderOption_E"
            });
        }
        //PLANUNGSSTAND
        if (this.hasFeature("Commdoc/PlanningEvServ")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_PlanningEvServ"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_planning_ev_serv"),
                iconClass: "fas fa-info",
                groupname: "info",
                position: "secondary",
                internalName: "createPlanningEvServ"
            });
        }
        if (this.hasFeature("Commdoc/PlanningEvServ_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_PlanningEvServ_E"),
                //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_planning_ev_serv_E"),
                iconClass: "fas fa-info",
                groupname: "info",
                position: "secondary",
                internalName: "createPlanningEvServ_E"
            });
        }
        if (this.hasFeature("Commdoc/CreateServiceContract")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_ServiceContract"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_service_contract"),
                iconClass: "fas fa-file-signature",
                groupname: "contract",
                position: "secondary",
                internalName: "createServiceContract"
            });
        }
        if (this.hasFeature("Commdoc/CreateServiceContract_E")) {

            this.addButtonEx({
                label: this.translate("Commdoc_Label_ServiceContract_E"),
                callback: lang.hitch(this, this._askCommdocOptions, "project_service_contract_E"),
                iconClass: "fas fa-file-signature",
                groupname: "contract",
                position: "secondary",
                internalName: "createServiceContract_E"
            });
        }
        /*
        if (menu.getEntryCount() > 0) {
            menu.open(evt);
        } else {
            if (this.hasUserRole("_DEV")) {
                alert("Hallo, DEV: Es sind keine kfm Dokumente in den Customersettings konfiguriert! \r\n" +
                    "Modul 'Commdoc' prüfen!(Commdoc / CreatePrepayment, Commdoc / CreateInvoice...) \r\n" +
                    "oder EvProject/CommdocMenu entfernen");
            } else {
                menu.addEntry({ callback: null, label: this.translate("General_NoEntries"), enabled: false });
                menu.open(evt);
            }

        }*/
    }
    private _askCommdocOptions(customtype: VAM2types.CommdocTypes): void {


        // LEGACY

        if (/*FeatureHelpers.hasModuleVersion("EvProject", null, 260400) || */FeatureHelpers.hasFeature("EvProject/UseLegacyCommdocCreation")) {
            switch (customtype) {
                case "project_prepayment":
                case "project_prepayment_E":
                    {
                        let dlg = new GenericDialog();
                        let form = this.UiModder.domConstruct.create("div");
                        let offerPrice = this.currentData["offer_price_total"] ? this.currentData["offer_price_total"] : 0.0;
                        let prepaymentPrice = 0.0;

                        let row = this.UiModder.domConstruct.create("div", {
                            class: "w3-section w3-row w3-large",
                            innerHTML: `${this.translate("ProjectWizard__commdocs_offerAmount")}: <b>${offerPrice} €</b>`
                        }, form);

                        row = this.UiModder.domConstruct.create("div", {
                            class: "w3-row w3-padding",
                        }, form);

                        let numberInput = new NumberInput();
                        numberInput.setMaxRange(100);
                        numberInput.setMinRange(0);
                        numberInput.setStep("0.01");

                        numberInput.setLabel(this.translate("ProjectWizard__commdocs_label_setPercentage"));

                        numberInput.placeAt(row);

                        row = this.UiModder.domConstruct.create("div", {
                            class: "w3-section w3-row w3-large",
                            innerHTML: `${this.translate("ProjectWizard__commdocs_prepaymentPrognose")}: <b>${prepaymentPrice.toFixed(2)} €</b>`
                        }, form);
                        numberInput.on("change", () => {

                            prepaymentPrice = offerPrice * numberInput.getValue() / 100;

                            this.UiModder.domAttr.set(row, "innerHTML", `${this.translate("ProjectWizard__commdocs_prepaymentPrognose")}: <b>${prepaymentPrice.toFixed(2)} €</b>`)
                        });

                        dlg.show(form,
                            this.translate("ProjectWizard__commdocs_setPercentage"),
                            null, null,
                            "okcancel",
                            lang.hitch(this, this._sendDataForCommdoc, numberInput, customtype));
                    }
                    break;
                default:
                    // einfach weiter
                    this._prepareDataForCreateCommdoc(customtype);
                    break;
            }

            return;
        }

        switch (customtype) {


            default:
                let configPanel = new CommdocConfigPanel();
                configPanel.setup(this.entity, customtype);
                configPanel.on("commdocCreated", lang.hitch(this, this._onConfigPanelConfirmed));

                //Dialog ob nach dem Erzeugen des Commdocs Leistungsbuchungen manuell oder automatisch hinzugefügt werden sollen
                //this._openCommdocSelectionDlg(customtype, null);

                //this._prepareDataForCreateCommdoc(customtype as any);
                break;
        }
    }

    private _onConfigPanelConfirmed(data: { commdocID: string, file?: CreatedFileResponse }) {
        if (data.file && !data.file?.error) {
            this._commdocRelatedCall = true;
            this._onDownloadReady(lang.hitch(this, this._onCommdocCreated), data.file);
        }
        else this._onCommdocCreated();
    }

    private _openCommdocSelectionDlg(type: VAM2types.CommdocTypes, additionalData?: any) {

        if (FeatureHelpers.hasModuleVersion("Commdoc", 260200.0000)) {
            let dlg = new GenericDialog();
            dlg.addButtonEx({ internalName: "select", label: "Webtool_ProjectWizard_ButtonSelect", styleClass: "primaryBtn", iconClass: "fas fa-hand-pointer", callback: lang.hitch(this, this._onCommdocSelectionDlgCallback, type, additionalData, 1) });
            dlg.addButtonEx({ internalName: "auto", label: "Webtool_ProjectWizard_ButtonAuto", styleClass: "secondaryBtn", iconClass: "fas fa-recycle", callback: lang.hitch(this, this._onCommdocSelectionDlgCallback, type, additionalData, 0) });
            dlg.addButtonEx({ internalName: "cancel", label: "General_Cancel", styleClass: "", callback: lang.hitch(this, this._onCommdocSelectionDlgCallback, type, additionalData, -1) });

            dlg.open("Webtool_ProjectWizard_UserQuery_SelectModeEvPosVtCommdoc", "Webtool_ProjectWizard_Heading_CreateCommdoc");
        } else {
            this._onCommdocSelectionDlgCallback(type, additionalData, 0); // selectmode auto
        }
    }

    private _onCommdocSelectionDlgCallback(type: VAM2types.CommdocTypes, additionalData: any, choice: number) {
        if (choice === -1) {
            return;
        }
        else {
            if (!additionalData) additionalData = {};
            additionalData["selectMode"] = choice;
            this._prepareDataForCreateCommdoc(type, additionalData)
        }
    }

    private _sendDataForCommdoc(numberInput: MdsLax<InstanceType<typeof NumberInput>>, type: VAM2types.CommdocTypes, result): void {
        console.debug(numberInput, result);
        if (result !== 1) return;

        let percentage = numberInput.getValue();

        if (percentage <= 0 || percentage > 100) {

            this.showToast({
                title: this.translate("ProjectWizard__commdocs_setPercentage_errTitle"),
                message: this.translate("ProjectWizard__commdocs_setPercentage_errMessage"),
                iconClass: ToasterHelpers.ToasterIcons.notification,
                timeout: 20000
            });
            return;
        }

        //this._openCreateCommdocSelectionDlg(type, { percentage: percentage });
        this._prepareDataForCreateCommdoc(type as any, { percentage: percentage });
    }
    private _prepareDataForCreateCommdoc(type: VAM2types.CommdocTypes, additionalData?: any): void {

        let requestData = {
            "EvPlanningId": this.entityId,
            "type": type
        };
        //percentage

        if (additionalData) {
            // additionalData kann auch das Klickevent sein, falls kein dedizierter Parameter mitgegeben wurde!
            if (additionalData instanceof Event) {
                // nicht verwenden!
            } else {
                for (let key in additionalData) {
                    requestData[key] = additionalData[key];
                }
            }
        }

        let stringData = JSON.stringify(requestData);

        let selectionMode = additionalData && additionalData.selectMode ? additionalData.selectMode : null;

        this._createCommdoc(stringData, selectionMode);
    }

    private _commdocRelatedCall: boolean = false;
    private _createCommdoc(requestData: string, selectPosEvServFirst?: boolean): void {
        this.StandbyStart();

        let url = window.appRoot + "ProjectWizard/CommdocCreateDocument";
        let callback = lang.hitch(this, this._onCommdocCreated);

        if (selectPosEvServFirst) {
            // falls die Leistungspositionen gewählt werden müssen, kommen wir zuerst in ein anderes Callback
            this.RequestManager.post(
                url,
                {
                    jsonData: requestData
                },
                lang.hitch(this, this._onCommdocReadyForSelection, callback),
                lang.hitch(this, this._onProjectRequestError),
                false // sync
            );

        } else {

            if (this.hasUserRole("_DEV")) {
                console.log("_createCommdoc", url, requestData);
            }
            this._commdocRelatedCall = true;
            this._sendProjectRequest(url, requestData, callback, true);
        }

    }

    private _onCommdocCreated() {
        this.commdocList.reload();
        this.commdocExpander.toggleExpand(true);
        this.sectionCommdocs.scrollIntoView();
    }

    private _onCommdocReadyForSelection(altCallback: Function, response: { entityId: string }) {
        this.StandbyStop();

        if (!response?.entityId) {
            console.warn(this.id + " _onCommdocReadyForSelection: no entityId of created commdoc in response of CreateCommdoc. probably missing backend functions: check Webtool_API_Commdoc__PrepareCommdoc + Webtool_API_Commdoc__AddPosEvServData! skipping entity dialog for pos_ev_serv and continuing with download-ready callback...", response);
            this._onDownloadReady(altCallback, response as any)
        }

        this.openSelectEntityDialog(null, "selectEvServiceCommdoc", lang.hitch(this, this._onSEDCallbackCommdoc, response), null, { evProjectID: this.entityId, vtCommdocId: response.entityId });
    }

    private _onSEDCallbackCommdoc(vtCommdocData: { entityId: string }, mode: string, data: Array<string>, items: Array<more.EntityAPIResultExtended>) {

        switch (mode) {
            case "selectEvServiceCommdoc":
                vtCommdocData["posEvServData"] = data;
                let callback = lang.hitch(this, this._onCommdocCreated);
                this.StandbyStart();
                this.RequestManager.callfunction("Webtool_API_Commdoc__AddPosEvServData", vtCommdocData, lang.hitch(this, this._onDownloadReady, callback), lang.hitch(this, this._onProjectRequestError, null, null))
                break;
        }
    }


    private _previousRequestData: { retryOnError: boolean, currentRetryCount: number, url: string, jsonDataString: string, callbackSuccess: Function, callbackError: Function, customCallback: Function };
    private _sendProjectRequest(url: string, stringData: string, customCallback?: Function, retryOnError?: boolean, currentRetryCount?: number): void {

        let errorCallback = lang.hitch(this, this._onProjectRequestError) as any;
        let successCallback = lang.hitch(this, this._onDownloadReady, customCallback) as any;

        ToasterHelpers.removeToast("ProjectRequestError");

        this._previousRequestData = {
            retryOnError: retryOnError == true,
            currentRetryCount: currentRetryCount ? currentRetryCount : 0,
            callbackError: errorCallback,
            callbackSuccess: successCallback,
            jsonDataString: stringData,
            url: url,
            customCallback: customCallback
        };

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            successCallback,
            errorCallback,
            false // sync
        );
    }

    private filePreview: MdsLax<InstanceType<typeof filePreview>>;
    private _onDownloadReady(callback: Function, result: CreatedFileResponse) {
        this.StandbyStop();

        if (this._commdocRelatedCall == true && this.hasFeature("documentEditor", "useInCommdoc")) {
            // wenn dieses feature gesetzt ist, dann skippen wir den download, weil wir das bearbeiten von dokumenten erlauben -> kein download
            if (callback) callback();
            this._commdocRelatedCall = false;
            return;
        }

        if (this.hasUserRole("_DEV")) {
            console.log("_onDownloadReady", result);
        }


        if (this.hasFeature("filePreview", "useInProjectWizardV2") && result?.downloadKey) {
            this.filePreview = new filePreview();
            this.filePreview.show(
                { key: result.downloadKey },
                true,
                true,
                null,
                null
            );
            if (callback) callback();

        } else {

            // timeout, sonst funktioniert das Standbystop nicht !?
            if (result?.downloadKey) {
                setTimeout(lang.hitch(this, function (callback) {
                    if (result) {
                        this.fdh = new FileDownloadHandler();
                        this.fdh.downloadFromUrl(result.downloadKey);
                    }
                    if (callback) callback();

                }, callback), 600);
            } else if (result?.error && callback) callback();

            //if (this.hasFeature("EvProject/FileManage") && scrollToFiles === true) {
            //    setTimeout(lang.hitch(this, function () {
            //        this.loadProjectById(this.entityId);

            //        // bringt bei kfm Dokumenten nix: die stehen in einem eigenen Bereich!

            //        if (this.filesSection.isAvailable()) {
            //            this.filesSection.filesSectionContainer.toggleExpand(true);
            //            this.filesSection.domNode.scrollIntoView();
            //        }
            //    }), 1000);
            //}

        }
    }

    private _onProjectRequestError(error: more.requestErrorMessage) {

        if (this._previousRequestData && this._previousRequestData.retryOnError == true) {
            let retryCount = this._previousRequestData.currentRetryCount;
            let retryOnError = this._previousRequestData.retryOnError;
            let stringData = this._previousRequestData.jsonDataString;
            let url = this._previousRequestData.url;
            let customCallback = this._previousRequestData.customCallback;

            if (retryCount == null || retryCount == undefined) retryCount = 0;

            // nochmal versuchen, falls alles mitgegeben worden ist und bestimmte Fehler auftreten:
            if (retryOnError == true && error?.Message && retryCount < 3 && stringData) {
                retryCount++;

                console.warn("project request failed, retry #" + retryCount, url, error?.Message, stringData);

                this._sendProjectRequest(url, stringData, customCallback, retryOnError, retryCount);
                return;
            }
        }
        this.StandbyStop();
        ToasterHelpers.showToast({
            title: TranslationHelpers.tryTranslate("General_Error_RequestFailed"),
            message: error.Message,
            iconClass: toasterIcons.warning,
            timeout: "permanent",
            ID: "ProjectRequestError"
        });
        //alert(error?.Message);
    }


    private startCloneProcess(evt: MouseEvent) {

        if (!this.entity.ID) return;

        let dlg = new GenericDialog();

        let cloneForm = new EvProjectCopyForm();

        cloneForm.setup(this.entity, this.bookingList.getEntityListData() as any);

        dlg.show(cloneForm,
            this.translations["ProjectWizard__CopyEvProject"],
            null,
            null,
            "okcancel",
            lang.hitch(this, this._onCloneDlgResult, cloneForm, dlg));

        dlg._setOkBtnAttr(true, false); // ok anzeigen, aber disabled

        dlg.keepOpen = true;

        on(cloneForm, "result", lang.hitch(dlg, "_setOkBtnAttr", true)); // erster Parameter: anzeigen ja/nein, zweiter: enable Ja/nein

        dlg.show()
    }

    private _onCloneDlgResult(cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {

        if (result <= 0) {
            dlg.close(-1, true);
            return;
        }

        let data: VAM2types.CopyFormData_EvProject = cloneForm.getData();
        console.log("_onCloneDlgResult", data);

        dlg.disableAllButtons(true);
        this.StandbyStart(dlg.contentContainer);

        this.RequestManager.post(
            window.appRoot + "ProjectWizard/CopyEvProject",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onCopyEvProjectResponse, dlg, cloneForm),
            lang.hitch(this, this._onCopyEvProjectError, dlg)
        );
    }

    private _onCopyEvProjectResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, response: VAMtypes.CopyFormResponse<VAMtypes.EvProjectEntity_Short>) {

        this.StandbyStop();

        if (response.result == "success") {
            dlg.close(1, true);

            this.emit("cloned");
            topic.publish("EvProject/Cloned");

            if (this.isEmbeddedInTab) {
                let newProject = new ProjectWizardV2();
                newProject.show("tab", response.data.ev_project_name, this.getTabContainerName());
                newProject.loadProjectById(response.data.ID);

                //this.requestNewTabbedContent({
                //    widget: newProject,
                //    name: response.data.ID,
                //    label: response.data.ev_project_name,
                //    enableClosing: true,
                //    sidebarEntryName: response.data.ID
                //}, true);

                //newProject.loadProjectById(response.data.ID);
            }
        }

        else {

            dlg.disableAllButtons(false);
        }
    }

    private _onCopyEvProjectError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        this.StandbyStop();

        let errorDlg = new GenericDialog();
        errorDlg.show(error.Message, this.translations["General_SavingFailed"], null, ToasterHelpers.ToasterIcons.error);

        console.error(error.Message);

        dlg.disableAllButtons(false);
    }

    private _onClick_Validate_Button() {
        alert("_onClick_Validate_Button - NOT IMPLEMENTED YET");
    }

    onDirtyChange(dirtyState: boolean) {
        let isNew = this.entityId == null;

        this.createDefaultButton("save", lang.hitch(this, this.saveData))

        this.requestContextButtonDisable("save", !dirtyState);
        this.requestContextButtonDisable("rollback", !dirtyState && !isNew);

        this.setDirtyMarker(dirtyState);
    }

    private _onDirty_FilesSection(dirty: boolean) {
        let data = this.filesSection.getCurrentData();
        let diffData = this.filesSection.getChangedData();

        let filesData = {
            existingFiles: data["existingFiles"],
            newUploadFiles: data["newUploadFiles"]
        }

        console.debug(this.id + " _onDirty_FilesSection", filesData);

        if (dirty) {
            this.currentData["files_data"] = filesData;
            this.changedData["files_data"] = filesData;
            this.isDirty(true);
        } else {

        }
    }

    private _onDeletePrivilege(enable: boolean) {
        if (enable && this.entityId) {
            this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this.deleteEvProject));
        } else {
            this.requestContextButtonRemove("delete");
        }
    }
    private _onEditPrivilege(enable: boolean) {

        if (enable) {
            this.createDefaultButton("save", lang.hitch(this, this.saveData), false);
            this.createDefaultButton("rollback", lang.hitch(this, this.rollback), false);
            this.createDefaultButton("reload", lang.hitch(this, this._reload), true);
        } else {
            this.requestContextButtonRemove("save");
            this.requestContextButtonRemove("rollback");
            this.requestContextButtonRemove("reload");
            this.setReadonly(true);
        }
    }
    private _onReportsPriv(hasPriv: boolean) {

            if (hasPriv) {
                this.addButtonMenuEx({
                    label: this.translate("General_Label_Reports"),
                    internalName: "reports",
                    bIsGroupNextLevel: true,
                    iconClass: "fas fa-print"
                });

                this.addButtonEx({
                    callback: lang.hitch(this, this._onClick_ProjectReport),
                    label: this.translations["General_Label_ProjectReport"],
                    enabled: true,
                    groupname: "reports",
                    position: "secondary",
                    iconClass: "fas fa-file-alt",
                    internalName: "projectReport"
                });
            }
    }
    private _onCommdocPrivilege(hasPriv: boolean) {
        if (hasPriv && this.hasFeature("EvProject/CommdocMenu")) {

            this.addButtonMenuEx({
                label: this.translations["General_Label_Commdocs"],
                internalName: "commdocs",
                bIsGroupNextLevel: true,
                iconClass: "fas fa-file-alt",
            });

            this._onClick_OpenCommdocsMenu({});

            /*this.addButtonEx({
                callback: lang.hitch(this, this._onClick_Op enCommdocsMenu),
                label: this.translations["General_Label_Commdocs"],
                iconClass: "fas fa-file-alt",
                position: "secondary",
                internalName: "commdocs",
                enabled: !!this.entityId
            });*/
        } else {
            this.requestContextButtonRemove("commdocs");
        }
    }
    private _onClonePriv(hasPriv: boolean) {
        if (hasPriv) {
            this.addButtonEx({
                callback: lang.hitch(this, this.startCloneProcess),
                label: this.translations["ProjectWizard__CopyEvProject"],
                iconClass: "fas fa-clone",
                position: "secondary",
                internalName: "clone"
            });
        } else {
            this.requestContextButtonRemove("clone");
        }
    }
    private startOrchestraEmploymentMatrix() {
        if (!this.entityId) return;

        let dlg = new GenericDialog();


        let form = new OrchestraMatrix();
        form.mainMenuGlobalSpaceNode = dlg.leftActionContainerNode; // hier kommt die OM-toolbar hin
        form.directProjectId = this.entityId;

        this.UiModder.domStyle.set(form.domNode, {
            height: "800px",
            width: "100%"
        });

        this.UiModder.domStyle.set(dlg.modalDlgContentNode, {
            width: "80%"
        });

        //form.setup(this.entityData, this.bookingList.getEntityListData() as any);

        dlg.show(form,
            this.translations["OM__SchedulerMatrix"],
            null,
            null,
            "close");

        //dlg.keepOpen = true;
        dlg.show()

        this.UiModder.domClass.remove(dlg.leftActionContainerNode, "w3-hide");

        form.startup();
    }
    private _onCreatePrivilege(hasPriv: boolean) {
        if (hasPriv) {
            this.createDefaultButton("save", lang.hitch(this, this.saveData), false);
        }
    }

    private _handlePrivileges() {

        if (this.hasFeature("EvProject/BaseFormAMBACH")) {

            this.hideNode(this.sectionBaseFormAMBACH, !this.hasUserRole("Projects_Read"));
        }

        if (this.hasFeature("EvProject/BaseFormBOB")) {

            this.hideNode(this.sectionBaseFormBOB, !this.hasUserRole("Projects_Read"));
        }

        if (this.hasFeature("EvProject/BaseForm")) {

            this.hideNode(this.sectionBaseForm, !this.hasUserRole("Projects_Read"));
        }

        if (this.hasFeature("EvProject/FileManage")) {
            this.hideNode(this.sectionFiles, !this.hasUserRole("Projects_Read"));

            if (!this.getEntityId()) {
                this.hideNode(this.sectionFiles);
                return;
            }
        }

        if (!this.isPeriod) this.handleCommdocList();
        if (!this.isPeriod) this.handleCommunicationList();
        if (!this.isPeriod) this.handlePlannedMusicianList();
        if (!this.isPeriod) this.setupTravelBookingsSection();
        if (!this.isPeriod) this.handleEvProcessList();
        if (!this.isPeriod) this.handleTodoAppoinmentsList();

        this.hasUserRole("Projects_Delete",
            lang.hitch(this, this._onDeletePrivilege),
            this.entity);

        if (this.entityId) {
            this.hasUserRole("Projects_Edit",
                lang.hitch(this, this._onEditPrivilege),
                this.entity)

            this.hasUserRole("Projects_Report",
                lang.hitch(this, this._onReportsPriv),
                this.entity);

            this.hasUserRole(["Projects_Edit", "Commdoc_Create"],
                lang.hitch(this, this._onCommdocPrivilege),
                this.entity);

            this.hasUserRole(["Projects_Create", "Projects_Edit"],
                lang.hitch(this, this._onClonePriv),
                this.entity);

            if (this.hasUserRole(["OM", "OM_Matrix"]) /*&& this.hasFeature("System/ossentials")*/) {
                this.addButtonEx({
                    callback: lang.hitch(this, this.startOrchestraEmploymentMatrix),
                    label: this.translations["OM__SchedulerMatrix"],
                    iconClass: "fas fa-border-none",
                    position: "secondary",
                    internalName: "matrix"
                });
            }

        } else {
            this.hasUserRole("Projects_Create",
                lang.hitch(this, this._onCreatePrivilege),
                this.entity)
        }
    }

    private handleEvProgramList(): void {
        if (!this.hasFeature("EvProject/EvProgram")) {
            this.hideNode(this.sectionEvProgramList);
            this.UiModder.domConstruct.destroy(this.sectionEvProgramList);
            return;
        }


        if (this.evProgramList != null) {
            this.evProgramList.destroy();
            this.evProgramList = null;
        }


        if (!this.getEntityId()) {
            this.hideNode(this.sectionEvProgramList);
            return;
        }

        //this.hideNode(this.sectionEvProgramList, false);
        this.hasUserRoleAsync("Projects_EvProgram", this.entity).then(
            (hasRole) => {
                this.hideNode(this.sectionEvProgramList, hasRole !== true);
            },
            (rejected) => {
                console.error("hasUserRoleAsync rejected: ", rejected);
            }
        )

        this.evProgramList = new EvProjectProgramList();

        this.evProgramListExpander.setContent(this.evProgramList);



        //this.evProgramList.on("loaded", (hasEntries: boolean) => {
        //    this.evProgramListExpander.setMarking(hasEntries ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        //});

        let programList = this.getAttributeValue("evProgram") as Array<VAM2types.EvProgramEvProject>;
        let programListIndividual = this.getAttributeValue("evProgramIndividual") as Array<VAM2types.EvProgramEvProject>;
        this.evProgramList.setup(programList, programListIndividual, this.entityId);

        this.evProgramListExpander.setMarking(programList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (this.hasUserRole("EvProgram_Edit", null, this.entity)) {
            this.evProgramList.on("change", lang.hitch(this, this._onChange_EvProgram));
        }
    }

    private _onChange_EvProgram() {
        let data = this.evProgramList.getData();
        let list = data;

        this.evProgramListExpander.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);


        let newProgramData = this.evProgramList.getDiffData();

        console.debug(this.id + " _onChange_EvProgram", newProgramData, list);

        this.setAttributeValue("evProgram", newProgramData);
    }

    private handleInvolvedAddressesList(): void {
        if (!this.hasFeature("EvProject/InvolvedAddresses")) {
            this.hideNode(this.sectionInvolvedAddresses);
            this.UiModder.domConstruct.destroy(this.sectionInvolvedAddresses);
            return;
        }


        if (this.involvedAddressesList != null) {
            this.involvedAddressesList.destroy();
            this.involvedAddressesList = null;
        }


        if (!this.getEntityId()) {
            this.hideNode(this.sectionInvolvedAddresses);
            return;
        }

        this.hideNode(this.sectionInvolvedAddresses, false);

        this.involvedAddressesList = new InvolvedAddressesList();

        this.involvedAddressesListExpander.setContent(this.involvedAddressesList);
        this.involvedAddressesList.setCurrentProject(this.entity);

        let addressesList = this.getAttributeValue("involvedAddresses") as any;//Array<VAM2types.InvolvedAddresses>;

        this.involvedAddressesList.setData(addressesList);

        this.involvedAddressesListExpander.setMarking(addressesList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (this.hasUserRole("Projects_InvolvedAddresses", null, this.entity)) {
            this.involvedAddressesList.on("InvolvedAddresses_DataChanged", lang.hitch(this, this._onChange_InvolvedAddresses));
        }
    }

    private _onChange_InvolvedAddresses(data) {

        //    let list = this.involvedAddressesList.getCurrentData();

        //    this.involvedAddressesListExpander.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        //    let newInvolvedAddressesData = this.involvedAddressesList.getDiffData();

        //    console.debug(this.id + " _onChange_InvolvedAddresses", newInvolvedAddressesData, list);

        this.setAttributeValue("involvedAddresses", data, true);
    }

    private handleEvCastList(): void {
        if (!this.hasFeature("EvProject/EvCast")) {
            this.hideNode(this.sectionEvCastList);
            this.UiModder.domConstruct.destroy(this.sectionEvCastList);
            return;
        }


        if (this.evCastList != null) {
            this.evCastList.destroy();
            this.evCastList = null;
        }


        if (!this.getEntityId()) {
            this.hideNode(this.sectionEvCastList);
            return;
        }

        //this.hideNode(this.sectionEvCastList, false);
        this.hasUserRoleAsync("Projects_EvCast", this.entity).then(
            (hasRole) => {
                this.hideNode(this.sectionEvCastList, hasRole !== true);
            },
            (rejected) => {
                console.error("hasUserRoleAsync rejected: ", rejected);
            }
        )


        this.evCastList = new EvProjectCastList();

        this.evCastListExpander.setContent(this.evCastList);

        //this.evCastList.on("loaded", (hasEntries: boolean) => {
        //    this.evCastListExpander.setMarking(hasEntries ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        //});

        let castList = this.getAttributeValue("evCast") as Array<VAM2types.EvCastEvProject>;
        let castListIndividual = this.getAttributeValue("evCastIndividual") as Array<VAM2types.EvCastEvProject>;

        this.evCastList.setup(castList, castListIndividual, this.entityId);

        this.evCastListExpander.setMarking(castList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (this.hasUserRole("EvCast_Edit", null, this.entity)) {
            this.evCastList.on("change", lang.hitch(this, this._onChange_EvCast));
        }
        if (this.hasFeature("EvProject/PerformerContract")) {
            this.evCastList.on("performerContractSaved", lang.hitch(this, this._onCommdocSaved));
        }

        //this.evCastListExpander.setCounter(castList?.length);

    }

    _onCommdocSaved() {
        debugger;
        if (this.commdocList) this.commdocList.reload();
    }

    private _onChange_EvCast() {

        let data = this.evCastList.getData();

        let list = data;
        this.evCastListExpander.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        let newCastData = this.evCastList.getDiffData();

        console.debug(this.id + " _onChange_EvCast", newCastData, list);

        this.setAttributeValue("evCast", newCastData);
    }

    private handleCommdocList(): void {
        if (!this.hasFeature("EvProject/CommdocList")) {
            this.hideNode(this.sectionCommdocs);
            this.UiModder.domConstruct.destroy(this.sectionCommdocs);
            return;
        }

        if (this.commdocList != null) {
            this.commdocList.destroy();
            this.commdocList = null;
        }

        this.hideNode(this.sectionCommdocs);

        if (!this.getEntityId()) {

            return;
        }

        // Recht für Commdoc_Read prüfen!
        window.webPrivilegeManager.hasUserRole("Commdoc_Read", lang.hitch(this, this._continueHandleCommdocList), this.entity);
    }

    private _continueHandleCommdocList(hasPriv: boolean) {

        if (!hasPriv) {
            if (this.sectionCommdocs) {
                this.hideNode(this.sectionCommdocs);
            }

            if (this.commdocList) {
                this.commdocList.destroy();
                this.commdocList = null;
            }

            return;

        } else {
            this.hideNode(this.sectionCommdocs, false);
        }

        this.commdocList = new CommdocList();

        this.commdocExpander.setContent(this.commdocList);

        this.commdocList.on("loaded", (hasEntries: boolean) => {
            this.commdocExpander.setMarking(hasEntries ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        });

        this.commdocList.setup(VAMclassNames.ev_projects, this.entityId);
    }

    private handleCommunicationList(): void {
        if (!this.hasFeature("EvProject/CommunicationsList")) {
            //this.hideNode(this.sectionCommdocs);
            //this.UiModder.domConstruct.destroy(this.sectionCommdocs);

            // sollte sich schon selber destroyed haben, weil im template als feature angegeben
            return;
        }


        if (this.communicationList != null) {
            this.communicationList.destroy();
            this.communicationList = null;
        }


        if (!this.getEntityId()) {
            this.hideNode(this.sectionCommunicationList);
            return;
        }

        this.hideNode(this.sectionCommunicationList, false);

        this.communicationList = new communicationDisplayTable();

        this.communicationListExpander.setContent(this.communicationList);

        this.communicationList.on("loaded", (hasEntries: boolean) => {
            this.communicationListExpander.setMarking(hasEntries ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        });

        this.communicationList.on("requestEditor", lang.hitch(this, this._onRequest_CommunicationEditor)); // TODO: das muss weg, Liste soll sich ihren Editor selber tabben!

        this.communicationList.setup([{ Classname: VAMclassNames.ev_projects, ID: this.entityId }]);

    }

    private _onRequest_CommunicationEditor(editorWidget: MdsLax<InstanceType<typeof communicationEditor>>) {
        editorWidget.init(this.getTabContainerName());
    }

    private handlePlannedMusicianList(): void {
        this.hideNode(this.sectionPlannedMusicans);

        if (!this.hasUserRole(["OM", "Projects_OM"])/* && !this.hasUserRole("Ossentials")*/) {
            this.UiModder.domConstruct.destroy(this.sectionPlannedMusicans);
            return;
        }

        if (this.plannedMusicianList) {
            this.plannedMusicianList.destroy();
            this.plannedMusicianList = null;
        }


        let plannedMusicians = this.getAttributeValue("plannedMusicians");

        if (plannedMusicians && this.getEntityId()) {
            this.hideNode(this.sectionPlannedMusicans, false);

            this.plannedMusicianList = new OMplannedMusicianList();
            this.plannedMusicianList.setup(plannedMusicians, this.getEntityId());

            let expander = this.plannedMusicansExpander;
            expander.setContent(this.plannedMusicianList.domNode);
            expander.setMarking(plannedMusicians.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }




        /*
        if (this.commdocList != null) this.commdocList.destroy();

        this.commdocList = new CommdocList();

        this.commdocExpander.setContent(this.commdocList);

        this.commdocList.on("loaded", (hasEntries: boolean) => {
            this.commdocExpander.setMarking(hasEntries ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        });

        this.commdocList.setup(VAMclassNames.ev_projects, this.entityId);*/

    }

    private handleEvProcessList(): void {
        if (!this.hasUserRole("Projects_EvProcess") || !this.hasFeature("EvProject/EvProcess")) {
            this.UiModder.domConstruct.destroy(this.sectionEvProcess);
            return;
        }

        if (this.evProcessTable) {
            this.evProcessTable.destroy();
            this.evProcessTable = null;
        }

        if (!this.getEntityId()) {
            this.hideNode(this.sectionEvProcess);
            return;
        }


        let evProcesses = this.getAttributeValue("evProcesses");

        //Set to empty and reset dirty so wizard can recognize when table is reloaded
        this.setAttributeValue("evProcessDiffData", null);
        this.resetDirty();

        this.evProcessTable = new (mdsRequire2('WidgetCollection/EvProcess/EvProcessTable'))("project");
        this.evProcessTable.setData(evProcesses, this.entity as any);
        this.evProcessTable.on("change", lang.hitch(this, this._onChangeEvProcessTable));
        this.evProcessTable.on("reloaded", lang.hitch(this, this._onReloadEvProcessTable));

        this.evProcessTable.placeAt(this.sectionEvProcess);

        this.hideNode(this.sectionEvProcess, false);
    }

    private _onChangeEvProcessTable(diffData) {
        this.setAttributeValue("evProcessDiffData", diffData);
    }

    private _onReloadEvProcessTable() {
        this.setAttributeValue("evProcessDiffData", null);
    }

    private handleTodoAppoinmentsList(): void {
        if (!this.hasUserRole("EvProject_TodoAppointments") || !this.hasFeature("EvProject/TodoAppointments")) {
            this.UiModder.domConstruct.destroy(this.sectionTodoAppointments);
            return;
        }

        if (this.todoAppointmentsTable) {
            this.todoAppointmentsTable.destroy();
            this.todoAppointmentsTable = null;
        }

        if (!this.getEntityId()) {
            this.hideNode(this.sectionTodoAppointments);
            return;
        }

        let todoAppointments = this.getAttributeValue("todoAppointments");

        this.setAttributeValue("todoAppointmentsDiffData", null);


        this.todoAppointmentsTable = new TodoAppointmentsTable();
        this.todoAppointmentsTable.setData(todoAppointments, this.entity as any);
        this.todoAppointmentsTable.on("change", lang.hitch(this, this._onChangeTodoAppointmentTable));
        this.todoAppointmentsTable.on("reloaded", lang.hitch(this, this._onReloadTodoAppointmentTable));

        this.todoAppointmentsTable.placeAt(this.sectionTodoAppointments);

        this.hideNode(this.sectionTodoAppointments, false);
    }

    private _onChangeTodoAppointmentTable(diffData): void {
        this.setAttributeValue("todoAppointmentsDiffData", diffData);
    }

    private _onReloadTodoAppointmentTable(): void {
        this.setAttributeValue("todoAppointmentsDiffData", null);
    }

    private setupTravelBookingsSection(): void {
        if (!this.hasUserRole("Travel_Read") || !this.hasFeature("EvProject/Travel")) {
            this.hideNode(this.sectionTravelBookings);
            this.UiModder.domConstruct.destroy(this.sectionTravelBookings);
            return;
        }



        let travelBookings = this.getAttributeValue("travelBookings");

        if (this.travelBookingsList) {
            this.travelBookingsList.destroy();
            this.travelBookingsList = null;
        }

        if (travelBookings) {
            this.hideNode(this.sectionTravelBookings, false);
            this.travelBookingsList = new TravelBookingsList();
            this.travelBookingsList.setup(travelBookings, this.entity);
            this.travelBookingsList.startup();


            this.travelBookingsExpander.setContent(this.travelBookingsList);
            this.travelBookingsExpander.setMarking(travelBookings.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }
    }





    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.webPrivilegeManager) {
            alert("missing webPrivilegeManager! this module is needed for booking editor to work.");
            return;
        }

        this.RequestManager.handleAs = "jsonWithDate";

        this.baseForm.on("displayname", lang.hitch(this, this._onDisplaynameChange));
        this.baseFormBOB.on("displayname", lang.hitch(this, this._onDisplaynameChange));
        this.baseFormAMBACH.on("displayname", lang.hitch(this, this._onDisplaynameChange));

        if (this.hasFeature("EvProject/FileManage")) {
            this.filesSection.on("dirty", lang.hitch(this, this._onDirty_FilesSection));
        }

        this.SEDconfigCallfunction = "Webtool_API_ProjectWizardV2__SED_GetConfig";

        //    this.startup();
    }
    startup(): void {
        if (this.isStarted) return;
        super.startup.apply(this, arguments as any);

        this.selfSetup();

        this.isStarted = true;

        if (!this.entityId) this._handlePrivileges();
    }
    private isStarted: boolean = false;
    private isPrivilegesLoaded: boolean = false;
}

export default mdsWidget(ProjectWizardV2);
